export const ADD_STEP = 'ADD_STEP';
export const DELETE_STEP = 'DELETE_STEP';
export const DELETE_STEP_NUMBER= 'DELETE_STEP_NUMBER';
export const RECORD_STEP = 'RECORD_STEP';
export const ALTER_STEP_PARAMETER = 'ALTER_STEP_PARAMETER';
export const ALTER_TRACK_PARAMETER = 'ALTER_TRACK_PARAMETER';
export const DELETE_TRACK = 'DELETE_TRACK';
export const MOVE_STEPS = 'MOVE_STEPS';
export const DELETE_STEPS = 'DELETE_STEPS';
export const TOGGLE_STEP = 'TOGGLE_STEP';
export const DELETE_PATTERN = 'DELETE_PATTERN';
export const UPDATE_STEP_PARAMETER = 'UPDATE_STEP_PARAMETER';

// effects operations
export const ADD_EFFECT = 'ADD_EFFECT';
export const MOVE_EFFECT = 'MOVE_EFFECT';
export const DELETE_EFFECT = 'DELETE_EFFECT';
export const TOGGLE_EFFECT = 'TOGGLE_EFFECT';

// parameter options (for effects + instruments)
export const UPDATE_PARAMETER = 'UPDATE_PARAMETER';

// track
export const UPDATE_TRACK_VOLUME ='UPDATE_TRACK_VOLUME';
export const UPDATE_TRACK_MUTE ='UPDATE_TRACK_MUTE';

// automation
export const ADD_AUTOMATION_BREAK_POINT ='ADD_AUTOMATION_BREAK_POINT';
export const MOVE_AUTOMATION_BREAK_POINT ='MOVE_AUTOMATION_BREAK_POINT';
export const MOVE_AUTOMATION_BREAK_POINTS ='MOVE_AUTOMATION_BREAK_POINTS';
export const REMOVE_AUTOMATION_BREAK_POINT ='REMOVE_AUTOMATION_BREAK_POINT';
export const REMOVE_AUTOMATION_BREAK_POINTS = 'REMOVE_AUTOMATION_BREAK_POINTS';
export const SNAP_AUTOMATION_BREAK_POINT = 'SNAP_AUTOMATION_BREAK_POINT';

// quantiziation
export const SNAP_TO_GRID ='SNAP_TO_GRID';
export const RECORD_AUTOMATION = 'RECORD_AUTOMATION';
export const SMOOTH_AUTOMATION = 'SMOOTH_AUTOMATION';

export const LOAD_PROJECT_TRACKS = "LOAD_PROJECT_TRACKS";

export const AUDITION_PRESET = 'AUDITION_PRESET';

export const UNMAP_PLANAR_PARAMETERS = 'UNMAP_PLANAR_PARAMETERS';

export const BATCHED_ACTIONS = [RECORD_STEP, RECORD_AUTOMATION, UPDATE_PARAMETER];



